const actions = {
  show: 'show',
  yes: 'yes',
  dismiss: 'dismiss',
  no: 'no',
};

const labels = {
  gdpr: 'gdpr',
  gdprConsent: 'gdpr_consent',
  pause: 'pause',
  resume: 'resume',
  ccpaConsent: 'ccpa_consent',
};

const ad = {
  category: 'ad',
  actions,
  labels,
};

export default ad;
